import React from "react";
import { Box, Typography } from "@mui/material";

function MapContainer() {
  return (
    <Box sx={{ width: "100%", height: "100%", mt: 2 }}>
      <Typography sx={{ mb: 1, fontWeight: "bold" }}>
        German Standard Group
      </Typography>

      <iframe
        title="German Standard Group Location"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14445.721259824408!2d55.467431!3d25.154944!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f63963b884b69%3A0xecaab1c95cb58a06!2sGerman%20Standard%20Group!5e0!3m2!1sen!2sae!4v1761543412216!5m2!1sen!2sae"
        width="100%"
        height="400"
        style={{ border: 0, borderRadius: "10px",paddingBottom:10 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      
    </Box>
  );
}

export default MapContainer;